module.exports = __webpack_public_path__ + "img/logo.d7e3f053.png";